import { proxyCustomElement, HTMLElement } from '@stencil/core/internal/client';
import { u as unregisterLibrary, r as registerLibrary } from './icon-library-registry.js';

const iconLibraryCss = ":host{display:none}";

const IconLibrary = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.name = undefined;
    this.resolver = undefined;
    this.mutator = undefined;
  }
  handleUpdate() {
    // Subsequent registrations with the same name will invalidate existing ones
    this.register();
  }
  connectedCallback() {
    if (this.name && this.resolver) {
      this.register();
    }
  }
  disconnectedCallback() {
    unregisterLibrary(this.name);
  }
  register() {
    const { name, resolver, mutator } = this;
    if (resolver) {
      registerLibrary(name, resolver, mutator);
    }
  }
  render() {
    return null;
  }
  static get watchers() { return {
    "name": ["handleUpdate"],
    "resolver": ["handleUpdate"],
    "mutator": ["handleUpdate"]
  }; }
  static get style() { return iconLibraryCss; }
}, [1, "tt-icon-library", {
    "name": [1],
    "resolver": [16],
    "mutator": [16]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-icon-library"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-icon-library":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, IconLibrary);
      }
      break;
  } });
}

const TtIconLibrary = IconLibrary;
const defineCustomElement = defineCustomElement$1;

export { TtIconLibrary, defineCustomElement };
